var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CSidebar',{attrs:{"aside":"","show":"responsive","colorScheme":"light","fixed":false,"size":"sm"}},[_c('CInput',{attrs:{"placeholder":"Start typing..."}},[_c('CButton',{staticStyle:{"text-align":"right"}},[_vm._v("Search")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }